module.exports = __webpack_public_path__ + "static/img/image053.f9f8a4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image053.png
// module id = tkDl
// module chunks = 1